import React from "react";
import { useApp } from "../context/AppContext";
import { Zap, AlertCircle } from "lucide-react";

// Glanceable focus indicator for an entity.
// - compact (sidebar): a tiny right-aligned overdue badge takes priority; else a
//   muted quick-win count. Returns null when there's nothing to flag.
// - full (Group HQ tile): "{n} quick wins · {m} overdue" with icons/colors.
export default function FocusChip({ focus, compact = false }) {
  const { t } = useApp();
  if (!focus) return null;
  const qw = focus.quick_win || 0;
  const overdue = focus.overdue || 0;
  if (qw === 0 && overdue === 0) return null;
  const qwLabel = t(qw === 1 ? "focus_quick_win_label" : "focus_quick_wins_label");

  if (compact) {
    if (overdue > 0) {
      return (
        <span data-testid="focus-chip-compact"
          title={`${overdue} ${t("focus_overdue_label")}`}
          className="ml-auto shrink-0 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-semibold"
          style={{ color: "#F87171", background: "#F8717122" }}>
          {overdue}
        </span>
      );
    }
    return (
      <span data-testid="focus-chip-compact"
        title={`${qw} ${qwLabel}`}
        className="ml-auto shrink-0 inline-flex items-center gap-0.5 text-[10px] font-medium text-text-secondary">
        <Zap className="w-3 h-3" style={{ color: "#10B981" }} />{qw}
      </span>
    );
  }

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="focus-chip">
      {qw > 0 && (
        <span className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full font-medium"
          style={{ color: "#10B981", background: "#10B98118" }} data-testid="focus-chip-quickwins">
          <Zap className="w-3 h-3" /> {qw} {qwLabel}
        </span>
      )}
      {overdue > 0 && (
        <span className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full font-medium"
          style={{ color: "#F87171", background: "#F8717118" }} data-testid="focus-chip-overdue">
          <AlertCircle className="w-3 h-3" /> {overdue} {t("focus_overdue_label")}
        </span>
      )}
    </div>
  );
}
